import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import auth from '../utils/auth';
import { CDN_URL } from '../components/common/constants';

const DemoPage = () => {
  const { username } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [demoUser, setDemoUser] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState('');

  // Set random background image
  useEffect(() => {
    const randomImageNum = Math.floor(Math.random() * 17) + 1;
    const formattedNum = randomImageNum.toString().padStart(2, '0');
    const imageUrl = `${CDN_URL}/parki/app_theme/assets/img/auth_images/img_${formattedNum}.jpg`;
    setBackgroundImage(imageUrl);
  }, []);

  // Set page title
  useEffect(() => {
    document.title = 'Parki | Demo';
  }, []);

  // Handle demo login
  useEffect(() => {
    const loginToDemo = async () => {
      try {
        setLoading(true);
        const response = await auth.loginDemo(username);
        
        if (response.success) {
          setDemoUser(response.user);
        } else {
          setError(response.message || 'Unable to access demo');
        }
      } catch (err) {
        setError('There was an error accessing this demo');
        console.error('Demo login error:', err);
      } finally {
        setLoading(false);
      }
    };

    loginToDemo();
  }, [username]);

  const handleGetStarted = () => {
    history.push('/dashboard');
  };

  const handleGoToLogin = () => {
    history.push('/login');
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
        <div className="authentication-wrapper authentication-cover">
            {/* Logo */}
            <Link to="/" className="app-brand auth-cover-brand">
                <span className="app-brand-logo">
                    <div></div>
                    <img
                        src={`${CDN_URL}/parki/logo/Logo+files/PNGs+-+SVGs/SVG/Asset+5.svg`}
                        alt="Logo"
                        className="w-px-130 h-auto"
                    />
                </span>
            </Link>

            <div className="authentication-inner row m-0">
                {/* Left Side Banner */}
                <div className="d-none d-xl-flex col-xl-8 p-0">
                    <div className="auth-bg-img">
                        <img
                            src={backgroundImage}
                            alt=""
                            className="auth-cover-image"
                        />
                    </div>
                </div>

                {/* Auth Component (Login, Forgot Password, or Reset Password) */}
                <div className="d-flex col-12 col-xl-4 align-items-center authentication-bg p-sm-12 p-6">
                    <div className="w-px-400 mx-auto mt-12 pt-5">
                        {demoUser ? (
                        <>
                          <h3 className="fw-bold mb-4">Hi, {demoUser.given_name}! 👋</h3>
                          <div className="welcome-message">
                                <p className="lead mb-3">
                                    Welcome to your personalised Parki experience. <br></br><br /> This interactive demo shows you the main features of Parki.
                                </p>
                                <div className="feature-highlights mb-4">
                                    <p className="mb-2">
                                        <span className="text-primary me-2 fw-bold">📊</span>
                                        <span>Explore intuitive dashboards with real-time data visualisation</span>
                                    </p>
                                    <p className="mb-2">
                                        <span className="text-primary me-2 fw-bold">📈</span>
                                        <span>Access detailed reports on booking performance, finance, web & social media</span>
                                    </p>
                                    <p className="mb-0">
                                        <span className="text-primary me-2 fw-bold">🔍</span>
                                        <span>Build customised dashboards to suit your needs</span>
                                    </p>
                                </div>
                                <p className="text-muted fst-italic">
                                    Feel free to explore at your own pace. Have questions? Our team is ready to assist you!
                                </p>
                            </div>
                          <button 
                            className="btn btn-primary d-grid w-100 mb-3" 
                            onClick={handleGetStarted}
                          >
                            Get Started
                          </button>
                        </>
                      ) : (
                        <>
                          <h3 className="fw-bold text-danger mb-2">Demo Not Available</h3>
                          <p className="mb-8">
                            If you'd like to see Parki in action, <Link to="#">contact us</Link>
                          </p>
                          <button 
                            className="btn btn-primary d-grid w-100 mb-3" 
                            onClick={handleGoToLogin}
                          >
                            Go to Login
                          </button>
                        </>
                      )}
                    </div>
                </div>
            </div>
        </div>
    );

};

export default DemoPage;